import userAddressesActions from './user-addresses';
import userPhonesActions from './user-phones';
import userRolesActions from './user-roles';
import users from './users';

const usersActionCreators = {
  ...userAddressesActions,
  ...userPhonesActions,
  ...userRolesActions,
  ...users,
};

export default usersActionCreators;
